import React from "react";

const InternalServerError = () => {
  return (
    <div style={styles.container}>
      <div style={styles.message}>500 | Internal server error</div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f0f0',
  },
  message: {
    fontSize: '2rem',
    color: '#333',
  }
}

export default InternalServerError;